import * as React from "react";
const SvgStepBackward5Min20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m6.76 3.318.65-.76-1.519-1.301-.65.759-2.5 2.917-.558.65.558.651 2.5 2.917.65.76L7.41 8.608l-.65-.76-1.943-2.266 1.942-2.265Zm4.166 0 .65-.76-1.518-1.301-.65.759-2.5 2.917-.559.65.558.651 2.5 2.917.651.76 1.519-1.302-.651-.76L9.84 6.583h2.826a4.833 4.833 0 1 1 0 9.667h-1.834v2h1.834a6.833 6.833 0 1 0 0-13.667H9.84l1.085-1.265ZM2.8 16.347c.08 1.02 1.06 1.98 2.47 1.98 1.56 0 2.49-1.05 2.49-2.26 0-1.39-.92-2.17-2.22-2.17-.43 0-.89.14-1.17.4l.32-1.43h2.72v-1.19H3.75l-.77 3.33c.14.04 1.13.38 1.26.43.21-.24.56-.44 1-.44.6 0 1.15.35 1.15 1.09 0 .65-.5 1.06-1.12 1.06-.69 0-1.15-.49-1.18-1.09l-1.29.29Z",
      clipRule: "evenodd"
    })
  );
export default SvgStepBackward5Min20Px;
